import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import packageActionsImp from "../../../Actions/Voss/packageActions";
import { useNavigate, useSearchParams } from "react-router-dom";
import ProductGroupPriceAdjustment from "../../../Components/Voss/PriceAdjustment/ProductGroupPriceAdjustment";
import { Dropdown } from "../../../Components/FormComponents/Dropdown";
import { VossVersionStatus } from "../../../Components/Voss/VossVersionStatus";
import forms from "../../../Constants/forms";
import routes from "../../../Constants/routes";
import Spinner from "../../../Components/Fundamentals/Spinner/Spinner";
import Tabs from "../../../Components/Tabs/Tabs";

export function PriceAdjustmentFormContainer() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();
    const packageId = searchParams.get("Id");
    const versionId = searchParams.get("VersionId");

    const packageData = useSelector((state) => state.PackageReducer.package);
    const packageVersions = useSelector((state) => state.PackageReducer.packageVersions);
    const loading = useSelector((state) => state.CommonReducer.dataLoading.package || state.CommonReducer.dataLoading.priceAdjustmentForm);
    const form = useSelector((state) => state.FormReducer.forms[forms.priceAdjustmentFormData]);
    const packageActions = bindActionCreators(packageActionsImp, dispatch);

    const [tier, setTier] = useState(null);
    const [plan, setPlan] = useState(null);

    useEffect(() => {
        packageActions.getPackageVersions(packageId);
        return () => {
            packageActions.reset();
        };
    }, []);

    useEffect(() => {
        packageActions.beginPriceAdjustmentForm(packageId, versionId);
        packageActions.getPackage(packageId, versionId);
    }, [packageId, versionId]);

    useEffect(() => {
        if (packageData) {
            setPlan(packageData.plans?.[0]?.id || null);
            setTier(packageData.tiers?.[0]?.id || null);
        }
    }, [packageData]);

    const chargePlan = useMemo(() => {
        const chargePlanId = packageData?.chargePlans?.find(cp => cp.planId === plan && cp.tierId === tier)?.id;
        return form?.data?.chargePlans?.find(cp => cp.id === chargePlanId) || null;
    }, [tier, plan, form]);

    const onSelectVersion = (value) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set("VersionId", value);
        setSearchParams(newParams);
    }

    if (!packageData || !form || loading) return (
        <div className="mt-32" >
            <Spinner />
        </div>
    );

    const tierTabs = packageData?.tiers?.map((tier) => ({
        name: tier.id,
        label: tier.name,
        id: tier.id
    }));

    return <>
        <div>
            <h2 className="mb-0">
                <a onClick={() => navigate(routes.vossPriceAdjustments)}>Price adjustments</a>{` - ${packageData.name}`}
            </h2>
            <div className="d-grid column gap-32">
                <div>
                    <div className="my-24 border-top">
                        <Tabs
                            tabs={tierTabs}
                            initialTab={tierTabs?.[0]?.name}
                            onTabChange={(tab) => setTier(tab.name)}
                        />
                    </div>
                    <div className="max-w-max-content">
                        <Dropdown
                            value={plan}
                            label={"Choose plan"}
                            options={packageData.plans}
                            onChange={setPlan}
                        />
                    </div>
                </div>
                <div>
                    <div className="d-flex flex-xxl-row justify-content-between flex-xs-column gap-32">
                        <div>
                            {chargePlan && (
                                <div className="d-flex flex-row justify-content-between flex-wrap gap-16">
                                    <div className="d-grid gap-24 mb-0 col-xl-12 col-xxl-12 p-0">
                                        <ProductGroupPriceAdjustment
                                            productGroupPricings={chargePlan.productGroups}
                                            tier={packageData.tiers.find(t => t.id === tier)}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="col-xl-12 col-xxl-2 p-0 order-xxl-last order-xs-first">
                            <VossVersionStatus selectedVersion={packageData.versionId} status={packageData.status} versions={packageVersions} onSelectVersion={(value) => onSelectVersion(value)} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
}